import React, { useCallback, useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from '../app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { clearUser } from '../app/features/auth';
import { authApi } from '../services/api';
import { clearGlobalData } from '../app/features/globalData';
export const AppProvider = ({ children, }) => {
    const persistor = persistStore(store);
    const { dispatch } = store;
    const isExpired = useCallback(async (error) => {
        if (error.message === 'Expired') {
            dispatch(clearUser());
            dispatch(clearGlobalData());
        }
        return Promise.reject(error);
    }, [dispatch]);
    useEffect(() => {
        authApi.interceptors.response.use(undefined, isExpired);
    }, [isExpired]);
    return (React.createElement(Provider, { store: store },
        React.createElement(PersistGate, { loading: null, persistor: persistor }, children)));
};
